
function checkKokoroPayload(payload) {
    let status = true;
    let returnMessage = 'Pass';
    // Required keys
    const requiredKeys = ['model', 'text', 'voice_weights', 'speed'];
    for (const key of requiredKeys) {
        if (!Object.prototype.hasOwnProperty.call(payload, key)) {
            status = false;
            switch (key) {
                case 'model':
                    returnMessage = 'Please select a voice model.';
                    break;
                case 'text':
                    returnMessage = 'Please enter the text to be synthesized.';
                    break;
                case 'voice_weights':
                    returnMessage = 'Please assign at least one voice.';
                    break;
                case 'speed':
                    returnMessage = 'Please specify a valid speed (e.g., 1 or 1.1).';
                    break;
            }
            return { status, returnMessage };
        }
    }
    // Validate text
    if (typeof payload.text !== 'string' || payload.text.trim() === '') {
        status = false;
        returnMessage = 'Please enter some text.';
        return { status, returnMessage };
    }
    // Validate speed
    const speedNum = parseFloat(payload.speed);
    if (Number.isNaN(speedNum)) {
        status = false;
        returnMessage = 'Speed must be a number (e.g., 1 or 1.1).';
        return { status, returnMessage };
    }
    // Validate voice_weights
    let rawWeights;
    try {
        rawWeights = JSON.parse(JSON.stringify(payload.voice_weights));
    } catch (e) {
        status = false;
        returnMessage = 'Voice weights data is invalid.';
        return { status, returnMessage };
    }
    const entries = Object.entries(rawWeights);
    if (entries.length === 0) {
        status = false;
        returnMessage = 'Please assign at least one voice.';
        return { status, returnMessage };
    }
    for (const [voice, weight] of entries) {
        const w = parseFloat(weight);
        if (Number.isNaN(w) || w <= 0) {
            status = false;
            returnMessage = `The weight for "${voice}" must be a number greater than zero.`;
            return { status, returnMessage };
        }
    }
    return { status, returnMessage };
}

function checkCosyVoicePayload(payload) {
    let status = true;
    let returnMessage = 'Pass';
    // Required keys
    const requiredKeys = ['model', 'text', 'instruct_text'];
    for (const key of requiredKeys) {
        if (!Object.prototype.hasOwnProperty.call(payload, key)) {
            status = false;
            switch (key) {
                case 'model':
                    returnMessage = 'Please select a voice model.';
                    break;
                case 'text':
                    returnMessage = 'Please enter the text to be synthesized.';
                    break;
                case 'instruct_text':
                    returnMessage = 'Please enter the text for prompting.';
                    break;
            }
            return { status, returnMessage };
        }
    }
    // Validate text
    if (typeof payload.text !== 'string' || payload.text.trim() === '') {
        status = false;
        returnMessage = 'Please enter some text.';
        return { status, returnMessage };
    }
    // if (typeof payload.instruct_text !== 'string' || payload.instruct_text.trim() === '') {
    //     status = false;
    //     returnMessage = 'Please enter some instruct text.';
    //     return { status, returnMessage };
    // }
    if (typeof payload.instruct_text !== 'string') {
        status = false;
        returnMessage = 'Please enter some instruct text.';
        return { status, returnMessage };
    }
    return { status, returnMessage };
}

function checkIndexTTS2Payload(payload) {
    let status = true;
    let returnMessage = 'Pass';
    const hasText = typeof payload.text === 'string' && payload.text.trim() !== '';
    const hasChunks = Array.isArray(payload.text_chunks) && payload.text_chunks.some(chunk =>
        typeof chunk === 'string' && chunk.trim() !== ''
    );

    if (!hasText && !hasChunks) {
        status = false;
        returnMessage = 'Please enter the text to be synthesized.';
        return { status, returnMessage };
    }

    if (!payload.voice_name && !payload.voice_id && !payload.prompt_audio) {
        status = false;
        returnMessage = 'Please select a saved voice for IndexTTS2.';
        return { status, returnMessage };
    }

    if (payload.emo_random != null && typeof payload.emo_random !== 'boolean') {
        status = false;
        returnMessage = 'Random emotion must be true or false.';
        return { status, returnMessage };
    }

    return { status, returnMessage };
}

export function checkTTSPayload(payload) {
    let status = true;
    let returnMessage = 'Pass';

    if (
        !Object.prototype.hasOwnProperty.call(payload, 'model') ||
        typeof payload.model !== 'string' ||
        payload.model.trim() === ''
    ) {
        status = false;
        returnMessage = 'Please select a voice model.';
        return { status, returnMessage };
    }
    const modelName = payload.model.toLowerCase();
    if (modelName.includes('kokoro')) {
        const kokoroResult = checkKokoroPayload(payload);
        status = kokoroResult.status;
        returnMessage = kokoroResult.returnMessage;
        if (!status) {
            return { status, returnMessage };
        }
    }
    if (modelName.includes('indextts2')) {
        const indexResult = checkIndexTTS2Payload(payload);
        status = indexResult.status;
        returnMessage = indexResult.returnMessage;
        if (!status) {
            return { status, returnMessage };
        }
    }
    if (modelName.includes('cosyvoice')) {
        const cosyvoiceResult = checkCosyVoicePayload(payload);
        status = cosyvoiceResult.status;
        returnMessage = cosyvoiceResult.returnMessage;
        if (!status) {
            return { status, returnMessage };
        }
    }
    return { status, returnMessage };
}
